import MainContainer from './MainContainer'

const Home = ({setLoading}) => {
    return (
        <MainContainer setLoading={setLoading} />
    );
};

export default Home;
